export default {
	focusOnLoad: false,
	hideOnEmpty: true,
};
